import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-groen-projecten',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconGroenProjecten {

  render() {
    return (
      <svg data-name="Layer 1" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="M10 11H7c-3.86 0-7-3.14-7-7V2c0-.55.45-1 1-1h3c3.86 0 7 3.14 7 7 0 .54-.43.98-.97 1 .54.02.97.46.97 1s-.45 1-1 1M2 3v1c0 2.76 2.24 5 5 5h2.96C9.43 8.98 9 8.54 9 8c0-2.76-2.24-5-5-5z"/>
  <path d="M13 14h-3a1.003 1.003 0 0 1-.87-1.5c-.08-.15-.13-.32-.13-.5 0-3.86 3.14-7 7-7h3c.55 0 1 .45 1 1v1c0 3.86-3.14 7-7 7m-2-2h2c2.76 0 5-2.24 5-5h-2c-2.76 0-5 2.24-5 5"/>
  <path d="M10 19c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1s1 .45 1 1v10c0 .55-.45 1-1 1"/>
</svg>

    );
  }
}
